<template>
  <div class="navbar-container d-flex justify-content-between align-items-center" :style="bgColor">

    <!-- Left section (brand name, search input) -->
    <app-navbar-horizontal-layout-brand :toggle-vertical-menu-active="toggleVerticalMenuActive"/>

    <!-- Right actions divided in nav (brandme ai button, support button, notification and settings dropdown) -->
    <b-navbar-nav :class="`d-flex position-relative justify-content-end`">
      <!-- Options in all views except home-search -->
      <div class="nav align-items-center h-100 pl-1" v-if="this.$route.name !== 'home_search' && user_data">
        <div id="brandme-ai-button-container-navbar" @click="$router.push({name: 'brandme_AI', params: {section: 'community'}})"><button-modal class="button-brandme-ai-navbar"/></div>
        <b-tooltip class="d-xl-none" target="brandme-ai-button-container-navbar">{{ $t('textBmAI')}}</b-tooltip>

        <feather-icon 
          icon="PlusIcon" 
          class="add-proposal-button-nav d-none d-sm-block" 
          id="create_proposal" 
          @click="redirectOptionCreateProposal()"
          v-if="user_data !== null && rol === 'creator'"
        ></feather-icon>
        <b-tooltip v-if="user_data !== null && rol === 'creator'" target="create_proposal">{{$t('dashboard.createProposal')}}</b-tooltip>

        <b-icon v-if="!checkOutHome()" icon="headset" class="button-help d-none d-sm-block" @click="openChatSupport" id="headset-support-contact-navbar"/>
        <b-tooltip v-if="!checkOutHome()" target="headset-support-contact-navbar">{{$t('footer.support')}}</b-tooltip>

        <div id="notications-icon-main-navbar"><notification-dropdown class="d-none d-sm-block" v-if="user_data !== null && !checkOutHome()"/></div>
        <b-tooltip v-if="user_data !== null && !checkOutHome()" target="notications-icon-main-navbar">{{$t('notification')}}</b-tooltip>

        <user-dropdown v-if="user_data !== null"/>
      </div>
      <!-- Options only in home-search view -->
      <div v-else-if="user_data" class="d-flex align-items-center">
        <span class="m-0 text-white mr-1 cursor-pointer align-items-center d-flex white-space-nowrap" @click="$router.push({name: 'brandme_AI', params: {section: 'community'}})">
          <b-img :src="require('@/assets/images/svg/brandme_ia_white.svg')" class="image-icon-brandme-ia"></b-img>
          <span class="d-none d-md-block">{{ $t('textBmAI')}}</span>
        </span>
        <span class="text-white cursor-pointer mr-1 d-none d-md-block" @click="$router.push({name: 'dashboard-analytics'})">{{$t('dashboard.desk')}}</span>
        <span class="text-white cursor-pointer mr-1 d-none d-md-block" @click="$router.push({name: 'marcas'})">{{$t('dashboard.campaigns')}}</span>
        <span class="text-white cursor-pointer mr-1 d-none d-md-block" @click="$router.push({name: 'chat-proposal'})">Chat</span>
        <b-link href="https://brandme.la/faq/" target="_blank"><b-icon icon="headset" class="button-help d-none d-sm-block" /></b-link>
        <user-dropdown v-if="user_data !== null"/>
      </div>

      <!-- If the session does not exist and the user is in creator views -->
      <div v-if="!user_data && isInCreatorView()" class="d-none d-lg-flex align-items-center mr-custom-nav-no-session">
        <a class="m-0 text-white mr-1 cursor-pointer d-flex align-items-center" href="https://brandme.la/ia">
          <b-img :src="require('@/assets/images/svg/brandme_ia_white.svg')" class="image-icon-brandme-ia"></b-img>
          <span class="">{{ $t('textBmAI')}}</span>
        </a>
        <b-nav-item-dropdown class="mr-1" v-for="(button, index) in links" :key="index" right>
          <template #button-content>
            <p class="m-0 text-white">
              {{ button.name_button }}
              <feather-icon icon="ChevronDownIcon"></feather-icon>
            </p>
          </template>
          <b-dropdown-item v-for="(link, index_options) in button.options" :key="index_options" class="dropdown-item-options-link" @click="redirectionRoute(link.url)">
            <div class="d-flex align-items-center">
              <div class="container-logo-menu-item">
                <b-img :src="require(`@/assets/images/svg/${link.icon}.svg`)" class="logo-icon-menu-item"></b-img>
              </div>
              <div>
                <strong>{{ link.title }}</strong>
                <p class="m-0" v-if="link.subtitle">{{ link.subtitle }}</p>
              </div>
            </div>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-button v-if="!user_data && isInCreatorView()" pill variant="outline-light" class="button-session-outline"  @click="open_modal_login = true; update_modal_login = !update_modal_login">{{ $t('login_text') }}</b-button>
      </div>

      <div class="d-flex align-items-center d-lg-none mr-2" v-if="!user_data && isInCreatorView()">
        <b-button  class="d-none d-sm-block" pill variant="outline-light" @click="open_modal_login = true; update_modal_login = !update_modal_login">{{ $t('login_text') }}</b-button>
        <div @click="open_sidebar = true">
          <b-avatar variant="" class="ml-1 cursor-pointer avatar-nav-responsive"></b-avatar>
        </div>
      </div>
    </b-navbar-nav>


    <b-sidebar v-model="open_sidebar" backdrop shadow right class="sidebar-nav-responsive-public d-lg-none" v-if="!user_data && isInCreatorView()">
      <template #header>
        <div class="d-flex justify-content-end w-100 p-1">
          <feather-icon 
            icon="XIcon" 
            size="18" 
            class="d-block close-sidebar-icon"
            @click="open_sidebar = false"
          >
          </feather-icon>
        </div>
      </template>
      <div class="p-1">
        <a class="m-0 text-white cursor-pointer d-flex align-items-center item-list p-1" href="https://brandme.la/ia">
          <b-img :src="require('@/assets/images/svg/brandme_ia_white.svg')" class="image-icon-brandme-ia"></b-img>
          {{ $t('textBmAI')}}
        </a>
        <div v-for="(button, index) in links" :key="index">
          <div class="d-flex justify-content-between align-items-center cursor-pointer item-list p-1" @click="button.collapse = !button.collapse">
            <span>{{button.name_button}}</span>
            <feather-icon :icon="!button.collapse ? 'PlusIcon' : 'MinusIcon'"></feather-icon>
          </div>
          <b-collapse title="Creators" v-model="button.collapse">
            <div class="p-1 item-list ml-1" v-for="(link, index_options) in button.options" :key="index_options" @click="redirectionRoute(link.url)">
              <div class="d-flex align-items-center">
                <div class="container-logo-menu-item">
                  <b-img :src="require(`@/assets/images/svg/${link.icon}.svg`)" class="logo-icon-menu-item"></b-img>
                </div>
                <div>
                  <strong>{{ link.title }}</strong>
                  <p class="m-0" v-if="link.subtitle">{{ link.subtitle }}</p>
              </div>
            </div>
            </div>
          </b-collapse>
        </div>
        <div class="d-flex justify-content-center mt-2">
          <b-button pill variant="outline-light" @click="open_modal_login = true; update_modal_login = !update_modal_login">{{ $t('login_text') }}</b-button>
        </div>

      </div>
    </b-sidebar>
    <modal-login :open_modal="open_modal_login" :key="update_modal_login"></modal-login>
  </div>
</template>

<script>
import {
  BIcon,
  BLink,
  BNavbarNav,
  BImg,
  BTooltip,
  BButton,
  BAvatar,
  BSidebar,
  BCollapse,
  BNavItemDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import { getUserData } from '@/libs/utils/user';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import { isUrl } from '@/libs/utils/urls';

export default {
  data () {
    return {
      getUserData,
      rol: '',
      bgColor: '',
      dominio: window.location.host,
      open_modal_login: false,
      update_modal_login: false,
      open_sidebar: false,
      is_creador: this.user_data && this.user_data.is_superuser ? this.user_data.main_group.name === 'creator' : false,
      links: [
        {
          name_button: 'Marcas',
          options: [
            {
              title: 'Marketplace de Creadores de Contenido', 
              subtitle: 'Encuentra y contrata Influencers a un clic', 
              icon: 'marketplace_content_creators',
              url: { name: 'home_search'}
            },
            {
              title: 'BrandMe Influencer Software', 
              subtitle: 'Impulsa tus campañas de Influencer Marketing', 
              icon: 'brandme_influencer_software',
              url: 'https://brandme.la/brandme-influencer-marketing-suite/'
            },
            {
              title: 'Servicio Completo Influencer Marketing', 
              subtitle: 'Contrata un equipo de expertos que se encargue de todo', 
              icon: 'full_service',
              url: 'https://brandme.la/servicios/'
            },
          ],
          collapse: false
        },
        {
          name_button: 'Creadores',
          options: [
            {
              title: 'Crea una Propuesta', 
              subtitle: 'Empieza a vender contenido', 
              icon: 'create_proposal',
              url: { name: 'steps_proposal', params: {step: 'category'}}
            },
            {
              title: 'Campañas', 
              subtitle: 'Encuentra y colabora con Marcas', 
              icon: 'campaigns_navbar_no_session',
              url: { name: 'marcas'}
            },
          ],
          collapse: false
        },
        {
          name_button: 'Recursos',
          options: [
            {
              title: '¿ Cuánto cobrar por mis Posts en Instagram ?',
              icon: 'earn_post',
              url: 'https://brandme.la/cuanto-cobrar-en-instagram/'
            },
            {
              title: '¿ Cuánto dinero puedo ganar siendo YouTuber ?', 
              icon: 'earn_youtuber',
              url: 'https://brandme.la/cuanto-gano-siendo-youtuber/'
            },  
            {
              title: 'Generador de Hashtags en Instagram', 
              icon: 'hashtags_generator',
              url: 'https://brandme.la/generador-de-hashtags-en-instagram/'
            },
            {
              title: 'MicroInfluencers vs Celebridades', 
              icon: 'micro_vs_celebrities',
              url: 'https://brandme.la/microinfluencers-vs-celebridades/'
            },
            {
              title: 'Comunidad', 
              icon: 'community',
              url: 'https://brandme.la/comunidad/historias/'
            },
          ],
          collapse: false
        }
      ]
    }
  },

  components: {
    BButton,
    BIcon,
    BImg,
    BCollapse,
    BAvatar,
    BLink,
    BTooltip,
    BNavItemDropdown,
    BDropdownItem,
    BSidebar,
    // Navbar Components
    BNavbarNav,
    // DarkToggler,
    ModalLogin: () => import('@/views/components/modal/ModalLogin.vue'),
    NotificationDropdown: () => import('./components/NotificationDropdown.vue'),
    ButtonModal: () => import('../ButtonModal.vue'),
    UserDropdown: () => import('./components/UserDropdown.vue'),
    AppNavbarHorizontalLayoutBrand: () => import('./AppNavbarHorizontalLayoutBrand.vue'),
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    user_data() {
      return getUserData();
    },
  },
  created () {
    this.rol = this.user_data !== null ? this.user_data.groups.length > 0 ? this.user_data.groups[0].name : '' : '';
    if (this.dominio.includes('outofhome')) this.bgColor = 'background: #e74353'
    else this.bgColor = 'background: var(--header-bg);';
  },
  methods: {
    canCreateProposal() {
      return this.user_data && this.user_data.meta_info && this.user_data.meta_info.vanity_name && this.user_data.meta_info.vanity_name;
    },
    redirectionRoute(url) {
      if (isUrl(url)) window.location.href = url;
      else this.$router.push(url).catch(() => {})
    },
    openChatSupport() {
      this.$root.$emit('open_chat_hubspot')
    },
    checkRedirect() {
      this.$router.push({name: 'home_search'})
    },
    isInCreatorView() {
      const route = this.$route.name;
      const views_public_creator = [
        'user_profile',
        'home_search',
        'view_proposal',
        'creadores',
        'marcas',
        'view_casting_call',
        'new-detail-invitation-external'
      ];
      return (views_public_creator.find((view_creator) => view_creator === route));
    },
    redirectOptionCreateProposal() {
      if (this.canCreateProposal()) {
        this.$router.push({name: 'view_proposals_edit'})
      } else {
        this.$router.push({ name: 'my_work', params: { section: 'networks' } }).catch(() => {})
        loadToastificationContent().then((component) => {
          this.$toast({
            component: component.default,
            position: 'top-right',
            props: {
              title: this.$t('creator.createProfilePublic'),
              text: this.$t('creator.msjCreateProfilePublicProposals'),
              icon: 'AlertCircleIcon',
              variant: 'danger',
            }
          })
        })
      }
    },
    checkCoca() {
      return this.dominio.includes('coca')
    },
    checkOutHome() {
      return this.dominio.includes('outofhome')
    },
  }
}
</script>
<style lang="scss">
.button-brandme-ai-navbar {
  padding: 11px;
  &:hover {
    background-color: var(--header-text-hover);
    border-radius: 10px;
    
    cursor: pointer;
  }
}
.button-session-outline {
  position: absolute;
  right: 0;
  top: -0.6em;
}
.dropdown-item-options-link {
  font-size: 12px;
}
.container-logo-menu-item {
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #EBEAEA;
  margin-right: 0.7em;
  flex-shrink: 0;
  .logo-icon-menu-item {
    width: 28px;
    height: 28px;
    background-color: white;
    border-radius: 100%;
  }
}
.white-space-nowrap {
  white-space: nowrap;
}
.bm-logo{
  margin-left: 15px;
  margin-top: 8px;
}
.h-navbar-main {
  position: absolute;
  z-index: 100;
  height: 35px !important;
}
.item-list {
  font-size: 12px;
}
@media (max-width: 575px) {
  .position-absolute-logo-ooh {
    position: absolute;
    top: -8px;
  }
}
@media (min-width: 575px) {
  .position-absolute-logo-ooh {
    position: absolute;
    top: -8px;
    left: 2.5em;
  }
  .navbar-options-user {
    position: absolute;
    right: 2em;
  }
}
.sidebar-nav-responsive-public .bg-light {
  color: white !important;
  background: linear-gradient(0deg ,#6947bc, #993e90) !important;
}
.sidebar-nav-responsive-public .item-list:hover {
  background-color: rgba(0, 0, 0, 0.489);
  transition: all 500ms;
  border-radius: 0.5em;
}
</style>
<style scoped>
.mr-custom-nav-no-session {
  margin-right: 11em;
}
.image-icon-brandme-ia {
  width: 20px;
  height: 20px;
  margin-right: 0.5em;
}
.close-sidebar-icon:hover {
  background-color: rgba(219, 219, 219, 0.5);
  border-radius: 50%;
  cursor: pointer;
}
.add-proposal-button-nav {
  color: var(--header-text);
  padding: 8px;
  width: 3.125rem;
  height: 3.125rem;
}
.add-proposal-button-nav:hover {
  background-color: var(--header-text-hover);
  border-radius: 10em;
  cursor: pointer;
}
.button-help {
  color: var(--header-text);
  padding: 11px;
  width: 3.125rem;
  height: 3.125rem;
  cursor: pointer;
}
.button-help:hover {
  background-color: var(--header-text-hover);
  border-radius: 10em;
  cursor: pointer;
}
</style>